import { DateTime } from 'luxon';
import { ServerApi } from '../../../external/server/server.api';
import { NodeDoneStore } from './node-done.store';

async function fetchTodayCount() {
  const today = DateTime.now();
  const endOfToday = today.endOf('day');
  const count = await ServerApi.getTodayDoneCount(endOfToday.toMillis());
  NodeDoneStore.update({ todayCount: count.count });
}

export const NodeDoneService = {
  fetchTodayCount,
};
